<template>
  <div class="block" id="map_kv_data_err">
    <h2 style="font-size: 24px">
      KV数据查询
      <img
        class="img-help"
        src="@/assets/images/icon_help.png"
        @click="linkDesc"
      />
    </h2>
    <el-tag v-show="appId" class="ml-2" type="info"
      >该地图已被添加至AppID中，下方展示为AppID：{{
        appId
      }}
      的数据，非当前地图ID的数据。</el-tag
    >
    <title-name
      title=" "
      :btn="btnOptions"
      @selectChange="selectChange"
    ></title-name>
    <div class="content-inner-wrap">
      <div class="data-filter">
        <div v-if="productState.type === '2'" class="btnGroup">
          <span class="mgr25">数据表名</span>
          <el-input
            v-model="query.dataMapName"
            class="mgr25"
            style="width: 200px"
          />
          <span class="mgr25">数据KEY值</span>
          <el-input
            v-model="query.dataMapKey"
            class="mgr25"
            style="width: 200px"
          />
        </div>
        <div v-if="productState.type === '3'" class="btnGroup">
          <span class="mgr25">数据表名</span>
          <el-input
            v-model="query.namespace"
            class="mgr25"
            style="width: 200px"
          />
          <span class="mgr25">数据KEY值</span>
          <el-input v-model="query.key" class="mgr25" style="width: 200px" />
        </div>
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="query.selectDate[0]"
          type="datetime"
          :pickerOptions="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
        <span style="margin: 0 10px">~</span>
        <el-date-picker
          v-model="query.selectDate[1]"
          type="datetime"
          disabled
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <template v-if="productState.type !== '2'">
          <el-button @click="getList" class="search_btn" type="info">
            查找
          </el-button>
          <span>
            <el-radio-group v-model="dayNum" size="medium" @change="clickDate">
              <el-radio-button label="2">近2天</el-radio-button>
              <el-radio-button label="7">近7天</el-radio-button>
              <el-radio-button label="14" v-if="productState.type == '1'"
                >近14天
              </el-radio-button>
            </el-radio-group>
          </span>
        </template>
        <span
          class="download-wrap"
          v-if="productState.type === '2'"
          @click="exportFn"
        >
          <img src="@/assets/images/icon_export.png" />
          <span>导出数据</span>
        </span>
      </div>
      <!-- 添加筛选 -->
      <div class="data-table" v-loading="productDetailLoading">
        <template v-if="productState.type === '1'">
          <el-table class="data-box" border :data="list" stripe>
            <el-table-column
              scope="row"
              label="异常情况"
              prop="label"
              align="center"
            ></el-table-column>
            <el-table-column
              scope="row"
              label="异常次数"
              prop="value"
              align="center"
            ></el-table-column>
            <template slot="empty">
              <div class="img-no" v-if="showDefault">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
        </template>
      </div>
    </div>
    <el-dialog :title="kvAllLogTitile" :visible.sync="showDialog" width="68%">
      <span class="download-wrap" @click="exportAllKvLogs">
        <img src="@/assets/images/icon_export.png" />
        <span>导出数据</span>
      </span>
      <div class="data-table" v-loading="productDetailLoading">
        <el-table
          id="kvAllLogTable"
          class="data-box"
          border
          :data="kvAllLogList"
          stripe
          height="520"
        >
          <el-table-column
            scope="row"
            label="id"
            prop="aid"
            width="180"
            align="center"
            :fixed="'left'"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="logId"
            prop="logId"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="数据表名"
            prop="namespace"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="数据KEY值"
            prop="key"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="房间id"
            prop="roomId"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="日志内容"
            prop="value"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="时间"
            prop="time"
            align="center"
            width="180"
          ></el-table-column>
          <template slot="empty">
            <div class="img-no">
              <img
                class="img-no-data"
                src="../../../assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <template #footer>
        <span>
          <el-button @click="showDialog = false">Cancel</el-button>
          <el-button type="primary" @click="showDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMapKVData,
  getMapKVAppId,
  exportMapKVData,
  getMapKVAllLogs,
} from '@/api/charts';
import titleName from './title-btn.vue';
import { formatDate, downloadFile, htmlToExcel } from '@/utils';

// const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 48 * 60 * 60 * 1000;
export default {
  components: {
    titleName,
  },
  data() {
    return {
      kvAllLogTitile: '',
      showDialog: false,
      productDetailLoading: false,
      dayNum: 2,
      appId: '',
      mapId: '',
      showDefault: false,
      list: [],
      productState: {
        type: '1', // 1 异常次数情况, 2 异常日志查询
      },
      query: {
        dataMapName: '',
        dataMapKey: '',
        namespace: '',
        key: '',
        selectDate: [],
      },
      btnOptions: [
        { label: '异常次数情况', id: '1' },
        { label: '异常日志查询', id: '2' },
        { label: '全部日志', id: '3' },
      ],
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          return (
            time.getTime() < Date.now() - 24 * 3600 * 1000 * 14 ||
            time.getTime() > Date.now()
          );
        },
      },
      DetailData: [],
      kvAllLogList: [],
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.query.selectDate = [
      formatDate(currTime - ONE_DAY),
      formatDate(new Date()),
    ];
    this.mapId = this.$route.query.id;
  },
  async mounted() {
    await this.getAppId();
    await this.getList();
  },
  methods: {
    exportAllKvLogs() {
      htmlToExcel.getExcel('#kvAllLogTable', this.kvAllLogTitile);
    },
    getList() {
      switch (this.productState.type) {
        case '1':
          this.getKvTimesList();
          break;
        // case '2':
        //   this.getAllLogs(); // TODO:
        //   break;
        case '3':
          this.getAllLogs();
          break;
        default:
          break;
      }
    },
    getAppId() {
      const params = {
        id: this.appId || this.mapId,
        startTime: this.query.selectDate[0],
        endTime: this.query.selectDate[1],
      };
      getMapKVAppId(params).then(res => {
        const id = res.data;
        this.appId = id === 0 ? '' : id;
      });
    },
    getAllLogs() {
      if (this.query.namespace.trim() == '*' && this.query.key.trim() == '*') {
        this.$message.error('不支持全量查询');
        return;
      }
      try {
        this.productDetailLoading = true;
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          ns: this.query.namespace,
          key: this.query.key,
        };
        if (params.ns === '' || params.key === '') {
          this.$message.error('请输入数据表名/数据KEY值');
          return;
        }
        this.kvAllLogTitile = `kv全部日志(${params.ns}-${params.key})`;
        getMapKVAllLogs(params).then(res => {
          console.log(' getMapKVAllLogs res', res);
          if (res.code === 0) {
            this.kvAllLogList = res.data.list;
            this.showDialog = true;
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.productDetailLoading = false;
      }
    },
    getKvTimesList() {
      try {
        this.productDetailLoading = true;
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
        };
        const arr = [];
        getMapKVData(params).then(res => {
          if (res.code === 0) {
            // 遍历对象
            for (let key in res.data) {
              if (res.data[key] !== 0) {
                arr.push({
                  label: this.filterList(key),
                  value: res.data[key],
                });
              }
              // console.log('key', key, res.data[key]);
            }
            this.list = arr;
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.productDetailLoading = false;
      }
    },
    selectChange(val) {
      this.productState.type = val;
    },
    clickDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      // this.query.selectDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 2) {
        this.startTime = nowTime - 48 * 60 * 60 * 1000;
      } else if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 14) {
        this.startTime = nowTime - 14 * 24 * 60 * 60 * 1000;
      } else {
        this.startTime = nowTime - 24 * 60 * 60 * 1000;
      }
      this.query.selectDate[0] = formatDate(this.startTime);
      // this.query.selectDate[1] = formatDate(this.endTime);
      this.getList();
    },
    linkDesc() {
      window.open(
        'https://dev-wiki.mini1.cn/cyclopdeia?wikiMenuId=2125&wikiId=2409',
      );
    },
    async exportFn() {
      if (!this.query.dataMapName || !this.query.dataMapKey) {
        this.$message.error('请输入查询条件');
        return;
      }
      const data = {
        aid: this.appId || this.mapId,
        startTime: this.query.selectDate[0],
        endTime: this.query.selectDate[1],
        namespace: this.query.dataMapName,
        key: this.query.dataMapKey,
      };
      try {
        const res = await exportMapKVData(data);
        downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    filterList(val) {
      const obj = {
        ods_get_failed: 'ODS get 失败',
        ds_update_cd_limit: 'KV update操作触发CD限制',
        ods_incr_failed: 'ODS increment 失败',
        ods_set_cd_limit: 'ODS set K操作触发CD限制',
        ods_remove_cd_limit: 'ODS remove K操作触发CD限制',
        ods_get_rank_qpm_limit: 'ODS get排行榜操作触发QPM限制',
        ds_set_cd_limit: 'KV set操作触发CD限制',
        ods_get_rank_failed: 'ODS get排行榜 失败',
        ods_set_qpm_limit: 'ODS set K操作触发QPM限制',
        ods_incr_cd_limit: 'ODS increment K操作触发CD限制',
        init_dsods_failed: '创建 DS/ODS 失败',
        ds_get_failed: 'DS get 失败',
        remove_dsods_qpm_limit: '删掉 DS/ODS 操作触发QPM限制',
        init_dsods_qpm_limit: '创建 DS/ODS 操作触发QPM限制',
        ds_get_qpm_limit: 'KV get操作触发QPM限制',
        ds_incr_failed: 'KV increment 失败',
        ds_incr_qpm_limit: 'KV increment操作触发QPM限制',
        ds_incr_cd_limit: 'KV increment操作触发CD限制',
        // 需要核对字段
        glb_set_qpm_limit: 'Global Set K操作触发QPM限制',
        glb_get_qpm_limit: 'Global Get K操作触发QPM限制',
        ods_remove_qpm_limit: 'ODS remove K操作触发QPM限制',
        ods_incr_qpm_limit: 'ODS increment K操作触发QPM限制',
        ds_update_qpm_limit: 'KV update操作触发QPM限制',
        ds_remkv_cd_limit: 'KV remove操作触发CD限制',
        ods_get_qpm_limit: 'ODS get K操作触发QPM限制',
        ds_remkv_qpm_limit: 'KV remove操作触发QPM限制',
        ds_set_qpm_limit: 'KV set操作触发QPM限制',
      };
      return obj[val];
    },
  },
  watch: {
    DetailData(val) {
      val.length ? (this.showDefault = false) : (this.showDefault = true);
    },
    'productState.type'(val) {
      if (val == 3) {
        // 订单查询
        this.money_type = 1;
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        this.month = `${year}${month < 10 ? '0' + month : month}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#map_kv_data_err {
  margin-bottom: 20px;
}
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f4f4f5;
  margin-right: 20px;
}
.btnGroup {
  margin-bottom: 15px;
}
.data-box {
  margin-top: 20px;
}
.download-wrap {
  // float: right;
  border-radius: 4px;
  font-size: 11px;
  // font-weight: 600;
  margin-top: 18px;
  margin-left: 20px;
  // display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b6ddf;
  img {
    margin-right: 8px;
  }
}
.mgr25 {
  margin-right: 25px;
}
</style>
